import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { ColorEvent } from 'ngx-color';
import Popper from 'popper.js';

import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-color-picker-ng',
    styleUrls: ['../../sharedStyles/base.scss', './colorPicker.component.scss'],
    templateUrl: './colorPicker.component.html'
})
export class ColorPickerComponent extends BaseComponent implements AfterViewInit {
    get includeGoogleAnalytics() { return false; }

    @ViewChild('colorPickerToggle') private readonly colorPickerToggleRef: ElementRef<HTMLDivElement>;
    @ViewChild('colorPickerContainer') private readonly colorPickerContainerRef: ElementRef<HTMLDivElement>;

    private colorPickerPopperRef: Popper;

    private _color: string = 'red';
    @Input()
    get color() { return this._color; }
    set color(val) {
        if (this._color !== val) {
            this._color = val;
            this.colorChange.emit(this._color);
            this.changeDetectorRef.detectChanges();
        }
    }
    @Output() readonly colorChange: EventEmitter<string> = new EventEmitter<string>();
    @Output() readonly openPicker: EventEmitter<string> = new EventEmitter<string>();

    @Input()
    get showColorPicker() { return this._showColorPicker; }
    set showColorPicker(val) {
        if (val !== this._showColorPicker) {
            this._showColorPicker = val;
            if (this._showColorPicker) {
                this.onShow();
            } else {
                this.onHide();
            }
            if (!(<any>this.changeDetectorRef).destroyed) {
                this.changeDetectorRef.detectChanges();
            }
        }
    }
    private _showColorPicker = false;

    @Input() siblingColorPickers: ColorPickerComponent[] = [];

    constructor(
        _vcr: ViewContainerRef,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {
        super(_vcr, true);
    }

    ngAfterViewInit() {
        this.colorPickerPopperRef = new Popper(this.colorPickerToggleRef.nativeElement,
            this.colorPickerContainerRef.nativeElement,
            {
                placement: 'bottom-end',
                positionFixed: true
            });
    }

    pickerColorChanged(e: ColorEvent) {
        const rgb = e.color.rgb;
        this.color = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${rgb.a})`;
    }

    private onShow() {
        this.hideSiblings();
        this.colorPickerPopperRef.update();
        window.addEventListener('mousedown', this.outsideClickHandler);
        window.addEventListener('dragstart', this.outsideClickHandler);
        this.colorPickerContainerRef.nativeElement.addEventListener('mousedown', this.insideClickHandler);
        this.openPicker.emit('opened');
    }

    private onHide() {
        window.removeEventListener('mousedown', this.outsideClickHandler);
        window.removeEventListener('dragstart', this.outsideClickHandler);
        this.colorPickerContainerRef.nativeElement.removeEventListener('mousedown', this.insideClickHandler);
    }

    private readonly outsideClickHandler = () => {
        this.showColorPicker = false;
    }

    private readonly insideClickHandler = (e: MouseEvent) => {
        e.stopPropagation();
    }

    private hideSiblings() {
        for (const sibling of this.siblingColorPickers) {
            sibling.showColorPicker = false;
        }
    }
}
